import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import AssetDashboard from "views/Components/AssetDashboard";
import CreateCourseCard from "views/Components/CreateCourseCard";
import { CloudUpload, Create, DoneAll } from "@material-ui/icons";
import CreateProjectCard from "./CreateProjectCard";
import NotificationContext from "views/Components/Context.js";
import {
  inviteUserAPI,
  createDataProjectAPI,
  deleteDataProjectAPI,
  cloneDataProjectAPI,
  getDataProjectsAPI,
} from "views/APIs/APIUtility";
import CreateDataProjectModal from "./CreateDataProjectModal";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  ...styles,
});

export default function DataGenerationBoard() {
  const [allDataGenerationProjects, setAllDataGenerationProjects] = useState(
    []
  );
  const [
    initialDataGenerationProjects,
    setInitialDataGenerationProjects,
  ] = useState([]);
  const { showNotification } = React.useContext(NotificationContext);
  const [
    createDataGenerationProjectModal,
    setCreateDataGenerationProjectModal,
  ] = useState(false);
  const [dataGenerationProjectAdded, setDataGenerationProjectAdded] = useState(
    false
  );
  const [loading, setLoading] = useState({ loading: true, message: "" });
  const identifier = "synthetic_data_generation";
  const identifierPrint = "Synthetic Data Generation";
  const path = "/synthetic_data_generation";
  const classes = useStyles();

  const getStatusIcon = (status) => {
    switch (status) {
      case "In Design Phase":
        return <Create style={{ color: "#435966" }} />;
      case "Ingestion Review":
        return <CloudUpload style={{ color: "#435966" }} />;
      case "Review":
        return <DoneAll style={{ color: "#435966" }} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading({ loading: true, message: "Loading Data Projects..." });
      try {
        const response = await getDataProjectsAPI();
        setAllDataGenerationProjects(response);
        setInitialDataGenerationProjects(response);
      } catch (error) {
        showNotification(error, "danger");
      } finally {
        setLoading({ loading: false, message: "" });
      }
    };
    fetchData();
  }, []);

  const handleSaveLabel = async (data) => {
    try {
      //   const formData = new FormData();
      //   formData.append("project_id", data._id);
      //   if (data.tags.length === 0) {
      //     formData.append("tags", []);
      //   }
      //   // Append each tag separately
      //   else {
      //     data.tags.forEach(tag => formData.append("tags", tag));
      //   }
      //   await updateWritingTagsAPI(formData);
      //   setAllWritings((prevWriting) =>
      //     prevWriting.map((writing) =>
      //       writing._id === data._id ? { ...writing, tags: data.tags } : writing
      //     )
      //   );
      showNotification("Project Created Successfully", "success");
    } catch (error) {
      showNotification(error, "danger");
    } finally {
    }
  };

  const handleInviteSend = async (data) => {
    try {
      const requestData = {
        collection_type: "synthetic_data_generation",
        project_id: data._id,
        invitee_email: data.email,
      };

      const response = await inviteUserAPI(requestData);

      const updatedProjectId = response.project_id;

      // Find the target asset
      const updatedAsset = allDataGenerationProjects.find(
        (asset) => asset._id === updatedProjectId
      );
      if (!updatedAsset) {
        return;
      }

      // Create a new invitee object
      const newInvitee = {
        invitee_name: response.name,
        email: response.email,
        status: "pending",
      };

      // Update or append the invitee
      const updatedInvitees = (updatedAsset.invitees || []).map((invitee) =>
        invitee.email === newInvitee.email
          ? { ...invitee, status: "pending" } // Update status if email matches
          : invitee
      );

      // If no match was found in map, add the new invitee
      const emailExists = updatedInvitees.some(
        (inv) => inv.email === newInvitee.email
      );
      if (!emailExists) {
        updatedInvitees.push(newInvitee);
      }

      const newAsset = {
        ...updatedAsset,
        invitees: updatedInvitees,
      };

      // Update the allCourses state
      const updatedWritings = allDataGenerationProjects.map((writing) =>
        writing._id === updatedProjectId ? newAsset : writing
      );

      setAllDataGenerationProjects(updatedWritings);
      setDataGenerationProjectAdded(true);
      showNotification("Invite sent successfully", "success");
    } catch (error) {
      showNotification(error?.message || "Failed to send invite", "danger");
    }
  };

  const handleCloneDataGenerationProject = async (projectData) => {
    try {
      setLoading({
        loading: true,
        message: "Cloning " + identifierPrint + "...",
      });
      const formData = new FormData();
      formData.append("project_id", projectData._id);

      const response = await cloneDataProjectAPI(formData);
      const updatedProjectId = response.project_id;
      const updatedAsset = allDataGenerationProjects.find(
        (asset) => asset._id === updatedProjectId
      );
      if (!updatedAsset) {
        return;
      }
      const newAsset = {
        ...updatedAsset,
        invitees: updatedAsset.invitees || [],
      };
      const updatedProjects = allDataGenerationProjects.map((project) =>
        project._id === updatedProjectId ? newAsset : project
      );
      setAllDataGenerationProjects(updatedProjects);
      setDataGenerationProjectAdded(true);
      showNotification("Project cloned successfully", "success");
    } catch (error) {
      showNotification(error, "danger");
    } finally {
      setLoading({ loading: false, message: "" });
    }
  };

  const handleDeleteDataGenerationProject = async (projectData) => {
    try {
      setLoading({
        loading: true,
        message: "Deleting " + identifierPrint + "...",
      });
      const formData = new FormData();
      formData.append("project_id", projectData._id);
      //   add delete api here
      await deleteDataProjectAPI(formData);
      setAllDataGenerationProjects(
        allDataGenerationProjects.filter(
          (project) => project._id !== projectData._id
        )
      );
      showNotification("Project deleted successfully", "success");
    } catch (error) {
      showNotification(error, "danger");
    } finally {
      setLoading({ loading: false, message: "" });
    }
  };

  const [newDataProjectDetails, setNewDataProjectDetails] = useState({
    name: "",
    description: "",
  });
  const [createDataProjectModal, setCreateDataProjectModal] = useState(false);

  const handleCreateDataProjectModalClose = () => {
    setCreateDataProjectModal(false);
    setNewDataProjectDetails({
      name: "",
      description: "",
    });
  };

  const handleCreateDataProject = async () => {
    setLoading({
      loading: true,
      message: "Creating " + identifierPrint + "...",
    });
    const formData = new FormData();
    formData.append("name", newDataProjectDetails.name);
    formData.append("description", newDataProjectDetails.description);

    try {
      const data = await createDataProjectAPI(formData);
      setAllDataGenerationProjects([...allDataGenerationProjects, data]);
      setDataGenerationProjectAdded(true);
      showNotification("Project created successfully", "success");
    } catch (error) {
      showNotification(error, "danger");
    } finally {
      handleCreateDataProjectModalClose();
      setLoading({ loading: false, message: "" });
    }
  };

  if (loading.loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress
          color="quCreateColor"
          className={classes.loaderClass}
        />
        <Typography
          variant="h6"
          style={{ marginLeft: 16, textTransform: "none" }}
        >
          {loading.message}
        </Typography>
      </Box>
    );
  }

  return (
    <div>
      <CreateDataProjectModal
        newDataProjectDetails={newDataProjectDetails}
        setNewDataProjectDetails={setNewDataProjectDetails}
        createDataProjectModal={createDataProjectModal}
        handleCreateDataProjectModalClose={handleCreateDataProjectModalClose}
        handleCreateDataProject={handleCreateDataProject}
      />

      <AssetDashboard
        path={"/create/synthetic_data_generation"}
        welcomeTitle="Synthetic Data Generation Projects Dashboard"
        welcomeSubtitle="Start by creating a new Synthetic Data Generation Project or reviewing your existing projects."
        allAssets={allDataGenerationProjects}
        setAllAssets={setAllDataGenerationProjects}
        initialAssets={initialDataGenerationProjects}
        noAssetMessage="Create or Review your Synthetic Data Generation Projects to get started."
        linkPath="/"
        state={{ identifier: "synthetic_data_generation" }}
        getStatusIcon={getStatusIcon}
        CreateAssetCard={CreateProjectCard}
        setCreateAssetModal={setCreateDataProjectModal}
        createAssetButtonText="Create Synthetic Data"
        handleSaveLabel={handleSaveLabel}
        handleInviteSend={handleInviteSend}
        asset_identifier="Synthetic Data Generation Project"
        handleDeleteAsset={handleDeleteDataGenerationProject}
        handleCloneAsset={handleCloneDataGenerationProject}
        assetAdded={dataGenerationProjectAdded}
        setAssetAdded={setDataGenerationProjectAdded}
        setInitialAssets={setInitialDataGenerationProjects}
      />
    </div>
  );
}
